<template lang="html">
<div class="wcc verify-email">
  <h2>Check Your Email</h2>
  <p>A verification email was sent to {{$store.state.auth.userData.email}}</p>
  <div class="wcc buttons">
    <Button :value="'Back'" v-hammer:tap="back" ></Button>
    <Button :value="'Resend'" :submitting="$store.state.auth.emailVerification.sending" v-hammer:tap="resend"></Button>
  </div>
</div>

</template>
<script>
  import Button from '@/components/Button.vue'
  export default {
    methods: {
      resend() {
        this.$store.dispatch('auth/sendEmailVerification')
      },
      back() {
        this.$store.dispatch('auth/redoSignUpNewUser')
      }
    },
    computed: {
      verified() {
        return this.$store.state.auth.userData.emailVerified
      }
    },
    mounted() {
      let checkVerification = setInterval(()=> {
        if(!this.verified) {
          this.$store.dispatch('auth/setUserData')
        } else {
          clearInterval(checkVerification)
        }
      }, 10000)
    },
    components: {
      Button
    }
  }
</script>
<style lang="scss">
.wcc.verify-email {
  text-align: center;
}
</style>